import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

import LoginPage from "../views/public/login/login";
import Home from "../components/home";
import Logout from "../components/logout";
import Clients from "../views/private/crud/clients/clients";
import Registrations from "../views/private/crud/registrations/registrations";
import Users from "../views/private/crud/users/users";
import Withholdings from "../views/private/crud/withholdings/withholdings";
import Administrators from "../views/private/crud/administrators/administrators";
import Beneficiaries from "../views/private/crud/beneficiaries/beneficiaries";
import Applications from "../views/private/crud/applications/applications";
import Credits from "../views/private/crud/credits/credits";
import Installments from "../views/private/crud/installments/installments";
import WithholdingsByPeriodReport from "../views/private/reports/withholdingsByPeriodReport";

const ProtectedApp = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/crud/clients" element={<Clients />} />
        <Route path="/crud/registrations" element={<Registrations />} />
        <Route path="/crud/users" element={<Users />} />
        <Route path="/crud/withholdings" element={<Withholdings />} />
        <Route path="/crud/administrators" element={<Administrators />} />
        <Route path="/crud/beneficiaries" element={<Beneficiaries />} />
        <Route path="/crud/applications" element={<Applications />} />
        <Route path="/crud/credits" element={<Credits />} />
        <Route path="/crud/installments" element={<Installments />} />

        <Route path="/reports/withholdings" element={<WithholdingsByPeriodReport />} />

        <Route path="/logout" element={<Logout />} />
      </Routes>
    </>
  );
};

export default ProtectedApp;
